import _slicedToArray from "/Users/mac/dev/larcade/ddl-front/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
// src/portal-manager.tsx
import { createContext } from "@chakra-ui/react-context";
import { jsx } from "react/jsx-runtime";
var _createContext = createContext({
    strict: false,
    name: "PortalManagerContext"
  }),
  _createContext2 = _slicedToArray(_createContext, 2),
  PortalManagerContextProvider = _createContext2[0],
  usePortalManager = _createContext2[1];
function PortalManager(props) {
  var children = props.children,
    zIndex = props.zIndex;
  return /* @__PURE__ */jsx(PortalManagerContextProvider, {
    value: {
      zIndex: zIndex
    },
    children: children
  });
}
PortalManager.displayName = "PortalManager";
export { usePortalManager, PortalManager };